import { Alert } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

export function PromptForErrorMessage({
  componentName,
  message,
}: {
  componentName: string;
  message: string;
}) {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  return (
    isEditing && (
      <Alert
        alertType="error"
        shouldHideIcon={false}
        isDismissible={false}
        alertFunction="dismissible"
        primaryAlertText={
          <p>
            <b>Error in &apos;{componentName}&apos; :</b> {message}
          </p>
        }
      />
    )
  );
}
